// const hostname = window.location.hostname;
const domainsMap = new Map();

// Supported domains
domainsMap.set("localhost", { env: "local" });
domainsMap.set("sinao.test", { env: "local" });
domainsMap.set("sinao.dev", { env: "staging" });
domainsMap.set("sinao.app", { env: "production" });
domainsMap.set("mydad.fr", { env: "production" });
domainsMap.set("forgerz.com", { env: "production" });

// Supported environments
const env = {
	local: {
		NAME: "local",
		SWAGGER_URL: "https://api.sinao.test/v1/swagger.yaml",
		SWAGGER_SERVER_ID: 2
		// COOKIE_DOMAIN: hostname.includes("localhost") ? "localhost" : `.${getDomain()}`
	},
	staging: {
		NAME: "staging",
		SWAGGER_URL: "https://api.sinao.dev/v1/swagger.yaml",
		SWAGGER_SERVER_ID: 1
		// COOKIE_DOMAIN: hostname.includes("localhost") ? "localhost" : `.${getDomain()}`
	},
	production: {
		NAME: "production",
		SWAGGER_URL: "https://api.sinao.app/v1/swagger.yaml",
		SWAGGER_SERVER_ID: 0
		// COOKIE_DOMAIN: hostname.includes("localhost") ? "localhost" : `.${getDomain()}`
	}
};

const branding = "https://api.sinao.app/v1/branding.json";

module.exports = { branding, env, domainsMap };
